<template>
<div>
    
    <form @submit="submit" class="item-editor-form">

        <b-form-group v-if="action == 'new'" :label="$t('route_view.line')" > 
            <lineSelect  v-model="item.linja"/>
        </b-form-group>

        <fg-input v-model="item.tunnus" :label="$t('route_view.id')" :disabled="action == 'item'"></fg-input>
        <fg-input v-model="item.nimi" :label="$t('route_view.name')" :disabled="inputDisabled"></fg-input>
        <fg-input v-model="item.kuvaus" :label="$t('route_view.description')" :disabled="inputDisabled"></fg-input>

        <label for="direction">{{ $t('route_view.direction') }}:</label>
        <directionSelect v-model="item.suunta" id="direction" :disabled="inputDisabled"/>

        <TimeInput :label="$t('route_view.switch_of_day')" :value="this.defaultPassingTime" v-model="item.vrkvaihtoaika" :disabled="inputDisabled"></TimeInput>

        <FormButtons
            @submit="submit" 
            :reset="false" 
            :submit="$UIPrivilegeUpdate('timetables', 'routes')" 
            :remove="action == 'item' && $UIPrivilegeDelete('timetables', 'routes')" 
            @remove="remove"
            :itemid="this.item.tunnus"
            :modalid="'routeEditModal'"
            :disableSubmit="loading"
            :disableRemove="loading"/>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
   
</div>    
</template>

<script>

import lineSelect from '@/components/Timetable/LineSelect';
import TimeInput from '@/components/Generic/TimeInput';
import directionSelect from '@/components/Timetable/DirectionSelect';
import moment from 'moment';

export default {
    components: {
        lineSelect,
        TimeInput,
        directionSelect
    },
    props: {
        item: {        
            default: function () {
                return {
                    "tunnus": null,
                    "nimi": null,
                    "kuvaus": null,
                    "suunta": null,
                    "vrkvaihtoaika": null,
                    "linja": null,
                }
            }        
         },
        action: { default: "new" }
    },
    data: function() {
        return  {
            ok: false,
            error: false,
            loading: false,
            infoType: "save",
            defaultPassingTime: null
        }
    },    
    created: function(){
        this.$store.dispatch('getSystemParameters').then((result) => {
            this.defaultPassingTime = result.system_switch_of_day;
            this.item.vrkvaihtoaika = this.timeString(this.defaultPassingTime);
        });
    },
    computed: {
        formattedItem() {
            const newItem = JSON.parse(JSON.stringify(this.item));
            if( newItem.vrkvaihtoaika && moment(newItem.vrkvaihtoaika, "H:mm", true).isValid() ) {
                newItem.vrkvaihtoaika = moment(newItem.vrkvaihtoaika, "HH:mm:ss")
            } else {
                newItem.vrkvaihtoaika = moment(this.timeString(this.defaultPassingTime), "HH:mm:ss");
            }
            return newItem; 
        },         
        inputDisabled(){
            return this.loading || !this.$UIPrivilegeU('timetables', 'routes');
        }      
    },    
    watch: {
        item(){
            if( this.item.vrkvaihtoaika && this.item.vrkvaihtoaika != 'undefined') {
                this.item.vrkvaihtoaika = this.timeString(this.item.vrkvaihtoaika);
            } else {
                this.item.vrkvaihtoaika = this.timeString(this.defaultPassingTime);
            }
            
            this.ok = this.error = this.loading = false;            
        } 
    },
    methods: {    
        timeString: function(time) {
			const formattedTime = moment(time, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('HH:mm');
			if (formattedTime.startsWith('Invalid')) 
				return '';
            else
                return formattedTime;
        },
        submit(event) {
            if( event ) 
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => { 
                this.$store.dispatch('timetable/updateRoute' , this.formattedItem).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    if( this.action === "new" ) {
                        this.$emit('newItem', this.item);
                    }
                })
            }, 1000);
        },
        onReset(event){
            event.preventDefault();
            this.item = {};              
        },
        remove() {
            this.infoType = "delete";
            this.loading = true;

            setTimeout(() => { 
                this.$store.dispatch('timetable/deleteRoute' , this.formattedItem).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                }) 
                .catch( () => { this.error = true; }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
        }
    }
}
</script>

